import { SIGNIN, SIGNUP, SIGNOUT, SIGNIN_ERROR, UPDATE_TOKEN, CLEAR_LOCAL_SESSION } from "../constants";

export default {
  signIn: () => {
    return { type: SIGNIN };
  },
  signUp: () => {
    return { type: SIGNUP };
  },
  signInError: () => {
    return { type: SIGNIN_ERROR };
  },
  /**
   * End the session on the server and in this browser, then navigate.
   *
   * @param {{ redirectTo?: string }} [params] where to land afterwards; the
   *   home page when omitted. An expired session passes `/signin`.
   */
  signOut: (params = {}) => {
    const { redirectTo } = params || {};
    return redirectTo ? { type: SIGNOUT, redirectTo } : { type: SIGNOUT };
  },
  updateToken: () => {
    return { type: UPDATE_TOKEN };
  },
  /**
   * Forget the standard session in this browser **only**: no `DELETE /sessions`,
   * no navigation, no data-store wipe. For the referral hand-over, where the
   * server has already replaced the standard cookies and a real SIGNOUT would
   * delete the `referral` cookie that was just minted.
   */
  clearLocalSession: () => {
    return { type: CLEAR_LOCAL_SESSION };
  }
};
